import React from 'react';
import { ClientData } from '../common/types/client-data';

const ClientDataContext = React.createContext({
  client: {} as ClientData,
  traceId: '',
});

export default ClientDataContext;
